import { type ILanguageKeys } from './interface'

export const frCa: ILanguageKeys = {
  threeMonths: '3 Mois',
  sixMonths: '6 Mois',
  tenMonths: '10 Mois',
  oneYear: '1 an',
  accessoriesSuppliesAndTools: 'Accessoires, fournitures et outils',
  account: 'Compte',
  add: 'Ajouter',
  ADD: 'Ajouter',
  addA: 'Ajouter un', // TO DO
  addACustomName: 'Ajouter un nom personnalisé',
  addAllToCart: 'Tout ajouter au panier',
  addAtLeastOneItemToList: 'Ajoutez au moins un élément à la liste', // TODO
  addItems: 'Ajouter articles',
  addItemsToGroup: 'Ajouter des éléments au groupe',
  additionalDetails: 'Détails supplémentaires',
  additionalFitmentInformationIsNeededBeforeResultsCanBeDisplayed:
    'Additional fitment information is needed before results can be displayed', // TODO
  additionalOptions: 'Options supplémentaires', //TO DO
  additionalOrderOptions: 'Options de commande supplémentaires',
  addJust: 'Ajouter uniquement',
  addManually: 'AJOUTER MANUELLEMENT',
  addNewList: 'Ajouter une nouvelle liste',
  addNewRow: 'Ajouter une nouvelle ligne',
  addParts: 'Ajouter pièces',
  addPartToList: 'Ajouter pièce à la liste',
  additionalQuoteOptions: 'Options de devis supplémentaires',
  addQuoteToCart: 'Ajouter devis au chariot',
  updateAndAddToCart: 'Mettre à jour et ajouter au panier', //TO DO
  addThenBy: `"Puis par"`,
  addToCart: 'Ajouter au chariot',
  addToList: 'Ajouter à la liste',
  addVehicle: 'Ajouter un véhicule',
  adhesives: 'Adhésifs',
  advancedSearch: 'Recherche Avancée',
  aftermarketPartAvailable: 'Pièce du marché secondaire disponible',
  all: 'Tout',
  actions: 'Actes', //TODO
  all31Days: 'Tout (31 jours)',
  allCarts: 'tous les chariots',
  allEngines: 'Tous les moteurs',
  allItemsFromEachCartWillBeRemovedAndCannotBeUndone:
    'Tous les articles de chaque chariot seront supprimés, sans pouvoir revenir.',
  allItemsFromThisOrderHaveBeenReturned: `Tous les articles de cette commande ont été retournés`,
  allianceConnect: 'Alliance Connect',
  allLines: 'Toutes les lignes',
  allOrders: 'Toutes les commandes',
  allParts: 'Toutes les pièces',
  allProducts: 'Tous les produits',
  allRightsReserved: 'Tous les droits sont réservés',
  allVehicles: 'Tous les véhicules',
  allVehiclesWereSavedAsQuotes:
    'Tous les véhicules ont été sauvegardés comme devis',
  alternateFor: 'Alternative à',
  amount: 'quantité',
  available: 'Disponible',
  amountRequestedCanBeOrderedButWillTakeLongerToBeDelivered:
    'La quantité demandée peut être commandée, mais avec une durée de livraison supérieure',
  amountRequestedUnavailableItCanBeOrderedFromOtherLocation:
    'amount requested unavailable, It can be ordered from other location',
  amountRequestedUnavailableAndCanBeOrderedFromOtherLocation:
    'La quantité demandée est indisponible à %, mais peut être commandée à d’autres emplacements.',
  anAdminWillBeReachingOutToYou:
    'Un administrateur vous contactera. Si vous ne recevez aucun message, veuillez contacter le support à la clientèle.',
  apply: 'Appliquer',
  applyChanges: 'Appliquer les modifications',
  applySort: 'Appliquer le tri', // TODO
  areNotAvailableInOurDatabase:
    'ne sont pas disponibles dans notre base de données.',
  areYouSureYouWantTo: 'Êtes-vous sûr de vouloir',
  areYouSureYouWantToCancelReturnRquest:
    'Êtes-vous sûr de vouloir annuler la demande de retour ?',
  areYouSureYouWantToDelete: 'Êtes-vous sûr de vouloir supprimer',
  areYouSureYouWantToEmptyYour: 'Êtes-vous sûr de vouloir vider le chariot',
  areYouSureYouWantToEmptyYourCart:
    'Êtes-vous sûr de vouloir vider le chariot ?',
  areYouSureYouWantToRemove: 'Êtes-vous sûr de vouloir enlever',
  areYouSureYouWantToRemoveTheReturnRequest: `êtes-vous sûr de vouloir supprimer la demande de retour:
    « Êtes-vous sûr de vouloir supprimer le % de cette demande de retour ?`,
  areYouSureYouWantToRemoveYour: 'Êtes-vous sûr de vouloir enlever votre',
  areYouSureYouWantToUpdate: 'Êtes-vous sûr de vouloir mettre à jour',
  arrivedLate: 'Arrivé en retard',
  arrivedOn: 'arrivé le %',
  at: 'à',
  atOtherLocations: '% à d’autres endroits',
  automaticEntry: 'entrée automatique.',
  automaticEntryYouHave: 'entrée automatique. Vous avez ',
  availability: 'Disponibilité',
  aVehicleWasNotFound:
    'Un véhicule n’a pas été trouvé. Veuillez sélectionner le véhicule manuellement.',
  awaitingShipment: `En attente d'expédition`,
  back: 'Revenir',
  backToAllDiagrams: 'Revenir à toutes les diagrammes',
  backToTop: 'Retour en haut',
  belowIsAListOfAllOE: `Vous trouverez ci-dessous une liste de toutes les pièces d'origine et de rechange, y compris les articles non vendus dans nos entrepôts. Cet outil est uniquement à titre de référence.`,
  backToCart: 'Revenir au chariot',
  backToLogin: 'Revenir à la connexion',
  backToOrders: 'Revenir à l’historique de commande',
  backToOrderDetails: 'Retour aux détails de la commande',
  backToPartType: 'Retour au type de pièce',
  backToInvoice: 'Retour aux détails de la facture',
  backToPreviousPage: 'Volver a la página anterior',
  backToSearchResults: 'Retour aux résultats de la recherche', //TODO - review
  backToReturnSelection: 'Retour à la sélection de retour',
  backToReviewItems: 'Revenir à la révision des articles',
  backToSavedQuotes: 'Revenir aux devis sauvegardés',
  backToVehicleDetails: 'Retour aux détails du véhicule', // TODO
  bestEmailToReachYouAt: 'Votre adresse de courriel préférée ',
  brand: 'Marque',
  brandAZ: 'Marque (A-Z)',
  brandZA: 'Marque (Z-A)',
  Brands: 'Marques',
  browseFile: 'Parcourir les fichiers',
  buyAgain: 'Acheter à nouveau',
  callForAvailability: 'Appeler pour savoir la disponibilité',
  callForPrice: 'Appeler pour savoir le prix',
  cancel: 'Annuler',
  cancelReturnRequest: 'Annuler la demande de retour',
  cannotDeleteCategory: 'La catégorie ne peut pas être annulée',
  cart: 'Chariot',
  cartId: 'Identifiant du panier',
  cartID: 'Identifiant du panier',
  cartOnlyHasLaborInIt: '% le chariot ne comprend que la main d’œuvre',
  cartsOnlyHaveLaborInThem: '% les chariot ne comprennent que la main d’œuvre',
  cartTotal: 'Total chariot',
  cat: 'Cat.',
  catalogDiagram: 'Diagramme du catalogue',
  categories: 'Catégories',
  category: 'Catégorie',
  categoryDeletionError: 'Erreur de suppression de la catégorie',
  categoryNameAlreadyExists: 'Le nom de la catégorie existe déjà',
  categoryNameExceedsChars: 'Le nom de la catégorie dépasse 30 caractères',
  change: 'changement',
  changedStoreDueToAvailability:
    'Magasin changé en raison de la disponibilité de l’article',
  changeGraphic: 'Changer de graphique',
  changeLoaction: 'Changer d’emplacement',
  changeLocation: 'Changer d’emplacement',
  changeVehicle: 'Changer de véhicule',
  chemicals: 'Substances chimiques',
  choosePartType: 'Choisissez le type de pièce',
  choosePartTypeDescription: `Optimiser ma recherche d'échange en affichant d'abord tous les types de pièces qui correspondent au numéro de pièce spécifié avant d'afficher mes résultats`,
  chooseVehicleSystem: 'Choisir système de véhicule',
  clear: 'claire',
  clearAll: 'Effacer tout',
  clearAllFilters: 'Effacer tous les filtres',
  clearFilters: 'Effacer les filtres',
  clearSearch: 'Effacer la recherche',
  clearSelections: 'Effacer les sélections',
  click: 'Cliquer',
  clickButtonBelowToBeginAddingItemsToThisGroup:
    'Cliquez sur le bouton ci-dessous pour commencer à ajouter des éléments à ce groupe',
  clickingThisPartWillChangeGraphic:
    'Cliquer sur cette partie changera le graphique affiché à présent',
  clickPartToSelectAndHighlight:
    'Cliquer sur cette partie pour la sélectionner et la souligner dans la liste ci-dessous',
  clickToViewAvailableMfgList: 'Cliquer pour voir la liste MFG disponible',
  clickToViewPrintPartNumbers:
    "Cliquer pour voir / imprimer les numéros d'article",
  close: 'Fermer',
  closeGroups: 'Fermer les groupes',
  code: 'Code',
  commentOptional: 'Commentaire (option)',
  comments: 'Commentaires',
  continueRquest: 'Continuer la demande',
  copiedToClipboard: 'Copié dans le presse-papiers',
  copypart: 'Copier une pièce',
  copyLineCodeFromPreviousRow:
    'Copier le code de ligne de la ligne précédente',
  copyToAllCarts: 'copier sur tous les paniers',
  confirm: 'Confirmer',
  confirmRequest: 'CONFIRM REQUEST',
  confirmOrder: 'Confirmer la commande',
  confirmation: 'Confirmation #',
  confirmationId: 'Confirmation d’identifiant',
  confirmationID: 'Identifiant de confirmation',
  confirmNewPassword: 'Confirmer le nouveau mot de passe',
  congratulationsThisOrderHasQualifiedFor:
    'Félicitations ! Cette commande s’est qualifiée pour ',
  congratulationsThisOrderQualifiesFor:
    'Félicitations ! Cette commande s’est qualifiée pour ',
  contactAdminToRequestPasswordReset:
    'Contacter l’administrateur pour demander la réinitialisation du mot de passe',
  contactSellerDirectlyForDeliveryUpdates:
    'Contactez le vendeur directement pour les mises à jour de livraison.',
  contactUs: 'Nous contacter',
  core: 'Fixe',
  coreCost: 'Coût fixe',
  coreFee: 'Frais fixe',
  coreList: 'Liste fixe',
  coreOnly: 'Noyau uniquement',
  corePrice: 'Prix fixe',
  cost: 'Coût',
  condensed: 'Condensé',
  costChangedFrom: 'Coût modifié de % à %', //TODO
  costBreakdown: 'Ventilation des coûts',
  costDetails: 'Détails du coût',
  costHighLow: 'Coût (élevé-faible)',
  costLowHigh: 'Coût (faible-élevé)',
  costSummary: 'Résumé du coût',
  courier: 'Courrier',
  createCategory: 'Créer la catégorie',
  createdDate: 'Date de création',
  createdOn: 'Créé le',
  crossReference: 'Référence Croisée',
  crossReferenceResults: 'Résultats des références croisées',
  createGroup: 'Créer groupe',
  createList: 'Créer liste',
  crossReferenceTool: 'outil de référence croisée',
  crossReferenceToolNoResults: 'OUTIL DE RÉFÉRENCE CROISÉE',
  crossReferenceTooltipMsg: `Utilisez notre outil de référence croisée pour obtenir une liste complète de toutes les pièces d'origine et de rechange interchangeables avec %`, // TODO
  current: 'Courant',
  customize: 'Personnaliser',
  customMakes: 'Fabrications personnalisées',
  customizeMakeList: 'Personnaliser la liste des marques',
  selectTheCartYouWantToAddItemsTo:
    'Sélectionnez le panier auquel vous souhaitez ajouter les articles',
  selectTheMakesThatYouWantToSeeWhenAddingAVehicle: `Sélectionnez les marques que vous souhaitez voir lors de l'ajout d'un véhicule`,
  customerName: 'Nom du client',
  cancelAddingItems: `Annuler l'ajout d'articles`, // TODO
  continueWorking: 'Continuer l’activité', // TODO
  areYouSureYouWantToCancelYourItemsWillNotBeAdded:
    'Êtes-vous sûr(e) de vouloir annuler ? Vos articles ne seront pas ajoutés.', // TODO
  customizeSearch: 'Personnaliser la Recherche',
  customizeSearchPreferences: 'Personnaliser les préférences de recherche',
  customName: 'Nom personnalisé',
  clearVehicle: 'Effacer le véhicule', //TO DO
  cscOnly: 'CSC Only', // TODO
  damagedPartInbox: 'Boîte de réception des pièces endommagées',
  dashboard: 'tableau de bord', //TODO
  date: 'Date',
  dateAdded: `Date d'ajout`, // TODO
  dateRange: 'Intervalle de date',
  dateRequested: 'Date demandée',
  delayedDeliveryDisclaimer:
    "We don't have sufficient quantity of this item available at the selected location. We will work on fulfilling this order, but delivery may be delayed.", // TODO
  delete: 'Supprimer',
  default: 'défaut',
  defaultVehicleType: 'Type de véhicule par défaut', // TODO
  defaultSetting: 'Défaut',
  defective: 'Défectueuse',
  deleteCategory: 'Supprimer catégorie',
  deleteFromGroup: 'Supprimer du groupe',
  deleteGroup: 'Supprimer groupe',
  deleteItemFromList: 'Supprimer articles des listes',
  deleteItems: 'Supprimer articles',
  deleteList: 'Supprimer liste',
  deleteMessage: 'Êtes-vous sûr de vouloir supprimer',
  deleteQuote: 'Supprimer devis',
  deleteQuotes: 'Supprimer devis',
  deleteQuotesOlderThan: 'Supprimer devis plus anciens de',
  deleteVehicle: 'Supprimer véhicule',
  delivered: 'Livré',
  deliveryMayBeDelayed: 'Delivery may be delayed', // TODO
  deliveryStatus: 'État de livraison',
  deliveryStatusUnavailable: 'Statut de livraison indisponible', // TODO
  deliveryStatusUnavailableOrderPlacedByOtherMeans:
    'Statut de livraison indisponible. Cette commande a été passée par téléphone, en personne ou à travers une autre application.', // TODO
  description: 'Description',
  descriptionAZ: '', //TODO
  descriptionZA: 'Description (Z-A)', //TODO
  descriptions: 'Descriptions',
  details: 'Détails',
  desktop: 'Bureau',
  diagram: 'Diagramme',
  diagrams: 'Diagrammes',
  didYouMeanToSearchFor: 'Vouliez-vous rechercher',
  dismiss: 'Rejeter',
  dispatchAndDelivery: 'Expédition et livraison',
  dispatchNotificationNotFound: `Notification d'expédition non identifiée`, // TODO
  dontAskPartTypeAgain: `Ne demandez plus "Type de pièce"`,
  dontAskManufacturerAgain: `Ne demandez plus « Du fabricant »`,
  dontShowThisAgain: `Ne montre plus ça`,
  doingSoWillRemoveAllItems: 'Cette action va supprimer tous les articles.',
  dragAndDrop: 'ou glisser-déposer ici',
  dragAndRearrangeTheItemsInThisListToArrangeThemInYourPreferredDisplayOrder: `Faites glisser et déposez les éléments de cette liste pour les organiser dans votre ordre d'affichage préféré`, // TODO
  duplicateVehicle: 'Doubler le véhicule',
  eachAndEveryPerfectStopProductPurchaseearnsanenrty:
    'Chaque achat d’un produit % donne une participation',
  eachQualifyingInvoiceTotalEarnsYouAnEntry:
    'Obtenez une chance de gagner pour chaque transaction admissible de 150 $ ou plus. Les utilisateurs de MyPlace4Parts obtiennent désormais une chance supplémentaire pour chaque tranche d’achats additionnels de 150 $',
  edit: 'Modifier',
  editCustomName: 'Modifier le nom personnalisé',
  editFitmentConditions: 'Modifier les conditions de montage',
  editItem: 'Modifier l’article',
  editList: 'Modifier la liste',
  editParts: 'Modifier les pièces',
  editSearch: 'Modifier la recherche',
  editUnknownItem: 'Modifier l’article inconnu',
  editVehicle: 'Modifier le véhicule',
  email: 'Courriel',
  emailAddress: 'Adresse de courriel',
  emailRequired: 'Courriel requis',
  emptyCart: 'Supprimer le chariot',
  endUserLicenseAgreement: 'Contrat de licence utilisateur final', // TODO
  engine: 'Moteur',
  english: 'Anglais',
  enterAPlateNumber: 'Entrer le numéro de plaque',
  enterCode: 'Entrer le code',
  enterNewPassword: 'Entrer le nouveau mot de passe',
  enterPart: 'Entrer le no. de pièce pour changer ou rechercher',
  enterVehicle: 'Entrer dans le véhicule', // TODO
  enterVin: 'Entrer le NIV',
  entryAddjust: 'entrée(s). Ajouter uniquement ',
  entryToDate: 'entrée(s) jusqu’à présent.',
  entryYouHaveReachedTheMaximumNumberOfEntriesYouHave:
    'entrée(s). Vous avez atteint le nombre maximum d’entrées. Vous avez ',
  error: 'Erreur', // TODO
  errorAddingProductsToTheCart: 'Erreur en ajoutant les produits au chariot',
  errorDeletingVehicle: 'Erreur en suppriment le véhicule',
  errorLoadingBannerPromotion: 'Erreur en chargeant la bannière promotionnelle',
  errorLoadingEntries: 'Erreur en chargeant les entrées',
  errorMovingList: 'Erreur en déplaçant la liste',
  errorOccurredWhileUpdatingVehicleName:
    'Une erreur a eu lieu lors de la mise à jour du nom du véhicule.',
  errorProcessingOrders: 'Erreur en traitant les commandes',
  errorUpdatingProductQuantity:
    'Erreur en mettant à jour la quantité du produit',
  errorValidatingList:
    'Une erreur a eu lieu lors de la validation de la liste.',
  deliverBy: '',
  estimatedDelivery: 'Livraison estimée',
  exactMatch: 'Correspondance exacte',
  existingCartWarningModal:
    'Vous avez dans votre chariot un véhicule qui correspond à ces spécifications. Voulez-vous utiliser un nouveau chariot ou combiner les produits dans le chariot existant % ?',
  expandAll: 'Étendre tout',
  experianAutocheck: 'Vérification Experian Autocheck',
  explanation: 'Explication',
  exportList: 'Exporter la liste',
  extraDetails: 'Détails supplémentaires', // TODO
  favorites: 'Favoris',
  failedToAddPartsToGroup: `Échec de l'ajout de pièces au groupe`, // TODO
  failedToImportTheList: `Échec de l'importation de la liste`, // TODO
  failedToLogin: 'échec de connexion',
  failedToSendReport: `Échec de l'envoi du rapport`,
  failedToGetReasons: `Impossible d'obtenir les raisons`,
  feelFreeToReachTextHD:
    ' Si vous pensez avoir atteint ce message par erreur ou si vous avez des questions, veuillez nous contacter.',
  failedToAcceptTermsAndConditions: `Échec de l'acceptation des conditions générales`, //TODO
  fieldsForShopUse: 'Champs utilisés par le magasin',
  filter: 'Filtre',
  filterBy: 'Filtrer par',
  filterByDateRange: 'Filtrer par intervalle de date',
  filterResults: 'Filtrer les résultats',
  filterSelectLines: 'Filtrer',
  filterSort: 'Filtrer et trier', // TODO
  filterSortResults: 'Filtrer et trier les résultats',
  filterGroupSearch: 'Rechercher %',
  filterGroupSearchNoResults: 'Aucun résultat pour "%"',
  applyFilters: 'Appliquer les filtres',
  filterVehicles: 'Filtrer les véhicules', // TODO
  fitmentConditions: 'Conditions de montage',
  fitsYears: 'Adéquat aux années',
  for: 'pour',
  forFullSweepstakesDetails: 'pour les détails complets du tirage au sort',
  forgotPassword: 'Mot de passe oublié%',
  formIcomplete: 'Formulaire incomplet',
  forShopUse: 'Uniquement pour l’utilisation du magasin',
  french: 'Français',
  general: 'Généralités ',
  getLaborData: 'Obtenir les données liées à la main d’œuvre',
  getThePerfectResults: `Obtenez des résultats parfaits`,
  getReport: 'Obtenez le rapport',
  gfx: 'GFX',
  gfxCatalog: 'Catalogue GFX',
  gfxSpecificAndAttributeConditions: 'Conditions spécifiques et attributs GFX ',
  gfxUnavailableForThisVehicle: 'GFX indisponible pour ce véhicule',
  go: 'Aller',
  goToAccessoriesSuppliesAndTools:
    'Aller à accessoires, fournitures et outils (AST)',
  goToCart: 'Aller au chariot',
  goToFirstPage: 'Aller à la première page',
  goToNextPage: 'Aller à la page suivante',
  goToPreviousPage: 'Retour à la page précédente',
  grandTotal: 'Total général',
  graphicId: 'Identifiant graphique',
  group: 'Groupe',
  groupName: 'Nom du groupe',
  groupNameAlreadyExists: 'Le nom du groupe existe déjà',
  groups: 'Groupes',
  hashTagParts: 'No. de pièces',
  hasBeenRemovedFromYourCart: 'a été retiré de votre panier.',
  hasChangedFrom: 'Cela a changé ', //TODO
  here: 'ici',
  hidden: 'caché',
  hideMore: 'Cacher plus',
  home: 'Accueil',
  homePage: 'Page d’accueil',
  hours: 'Programme',
  howToReadThisGraphic: 'Comment lire ce graphique',
  howToViewSearchResults:
    'Comment souhaitez-vous afficher vos résultats de recherche ?',
  id: 'IDENTIFIANT',
  itemWasnotAddedToYourCart: `L'article n'a pas été ajouté à votre panier`, //To DO
  ifYouDoNotReceiveEmailWithCode:
    'Si vous ne recevez pas de courriel contenant le code, veuillez contacter votre fournisseur de pièces', //TODO
  ifYouNeedThisGraphic:
    'si vous avez besoin de ce graphique et nous traiteront votre demande aussi vite que possible.',
  ifYouThinkThisIsAMistakeContactYourAdministrator: `Si vous considérez qu'il s'agit d'une erreur, contactez votre administrateur`, // TODO
  import: 'Importer',
  importantMessageAboutItemsInYourCart:
    'Message important concernant les articles dans votre chariot',
  importComplete: 'Importation effectuée',
  importFile: 'IMPORTER UN FICHIER',
  importFromFile: 'Importer depuis un fichier',
  importList: 'Importer la liste',
  importListDescription:
    'Importer plusieurs articles dans une liste à partir d’un fichier CSV. Elle devrait inclure des colonnes pour Groupe, MFR, Numéro de pièce, Qté de Stockage et Commentaires.',
  importListTemplateCSV: 'Utilisez notre liste de modèles (CSV)',
  inCart: 'Dans le chariot',
  increasedFromTo: '% est passé de % à %',
  interchange: 'Échanger',
  interchangeResultsAreAvailableText: `Les résultats d'échange sont disponibles exclusivement via le catalogue MyPlace4 Parts. En choisissant l'échange, vous serez redirigé vers les résultats de MyPlace 4 Parts.`,
  interchangesearch: `Recherche d'échange`,
  interchangeSearchTextError: `La longueur du texte d'échange doit être comprise entre 2 et 14 caractères`,
  interchangeDisclaimer: `Les résultats de l'échange sont fournis à titre indicatif seulement. L'application doit être vérifiée.`, // TODO
  interchangeInfoMessage: `Si vous ne voyez pas l'article que vous recherchez, essayez d'utiliser notre % pour voir une liste complète de toutes les pièces d'origine et de rechange interchangeables avec %.`,
  interchangeTooltipHeading: 'ÉCHANGE EN MP4P',
  interchangeFor: 'Échanger pour',
  invalidColumnNamesInTheUploadedFile:
    'Noms de colonnes non valides dans le fichier téléchargé', // TODO
  invalidListIdOrInvalidFile: 'Identifiant de liste ou fichier non valide', // TODO
  invalidEmailAddress: 'Adresse de courriel invalide',
  invalidPartNumberOrLineCode: 'Numéro de pièce ou code de ligne non valide', // TODO
  invalidRequestBody: 'Contenu de la requête non valide', // TODO
  invalidRequestParameters: 'Paramètres de la requête non valides', // TODO
  invalidSearchPattern: `Modèle de recherche invalide`,
  invalidVin: 'NIV invalide',
  invoiceNumber: 'Numéro de facture',
  invoiceDetails: 'InvoiceDetails', //TO DO
  invoicedOn: 'Facturé le',
  inputPartTypeThenHitEnter: `Saisissez le type de pièce, puis appuyez sur la touche « Entrée » / « Retour » pour rechercher`, //TO DO
  isNotAvailableInDatabase: 'n’est pas disponible dans notre base de données.',
  issueInAddingPartsToCart: `Un problème est survenu lors de l'ajout de vos articles au panier. Veuillez consulter la page du panier pour plus de détails`, //TODO
  item: 'Article',
  itemInYourCartCantBeFulfilled:
    '1 article dans votre chariot ne peut pas être fourni',
  itemInYourCartHasChangedPrice:
    '1 article dans votre chariot a changé de prix',
  itemInYourCartHaveInsufficientQuantity:
    '1 article dans votre chariot a changé de quantité',
  items: 'Articles',
  itemsAddedToTheCart: 'articles ajoutés au chariot',
  itemsAvailability: '% sur 8 disponible(s)',
  itemsInYourCartCantBeFulfilled:
    '% articles dans votre chariot ne peuvent pas être fourni',
  itemsInYourCartHaveChangedPrice:
    '% articles dans votre chariot ont changé de prix',
  itemsInYourCartHaveInsufficientQuantity:
    '% articles dans votre chariot ont changé de quantité',
  itemsPerPage: 'articles par page',
  itemsReflectTheCurrentPrices: 'Les articles reflètent les prix actuels',
  itemsRequireYourAttention: 'articles demandent votre attention',
  itemsRestock: 'Articles réapprovisionnés tous les quatre mois',
  itemsSelected: 'articles sélectionnés dans 1 liste',
  itemsWereNotTransferred: '% articles n’ont pas été transférés',
  itemsWillNotBeAddedToList: 'Les articles ne seront pas ajoutés à la liste', // TODO
  itemUnavailable: 'Article indisponible dans notre base de données.',
  itemUnavailableAtAllLocations:
    'Article indisponible dans tous les emplacements.',
  itemUnavailableAllLocations: '% Item unavailable at all locations', // TODO
  itemsUnavailableAllLocations: '% Items unavailable at all locations', // TODO
  itemvalidated: 'Article validé',
  itemWasNotAdded: 'articles non ajoutés au chariot',
  itemWasNotTransferred: '1 article n’a pas été transféré',
  jobs: 'Travaux',
  justAMoment: 'Veuillez patienter un moment.',
  labor: 'Main d’œuvre',
  laborCost: 'Coûts liés à la main d’œuvre',
  laborData: 'Données liées à la main d’œuvre',
  laborId: 'Identifiant de main d’œuvre',
  laborLookup: 'Rechercher main d’œuvre',
  laborOperationsDescriptions: 'Description des opérations de main d’œuvre',
  laborRate: 'Tarif de main d’œuvre',
  laborRatePerHour: 'Tarif de main d’œuvre par heure',
  laborsUpdated: 'Main d’œuvre mise à jour',
  last7Days: 'Derniers 7 jours',
  last12Months: 'Derniers 12 mois',
  last30Days: 'Derniers 30 jours',
  lastUsed: 'Dernière utilisation',
  lastUsedAZ: 'Dernière utilisation (ascendant)', //TODO
  lastUsedZA: 'Dernière utilisation (descendant)', //TODO
  learnMore: 'Learn more', // TODO
  license: 'Immatriculation',
  licensePlate: "Plaque d'immatriculation",
  lineCode: 'Code de ligne',
  Lines: 'Lignes',
  list: 'Liste',
  listBinDoesNotExist: `L’emplacement de liste n'existe pas`, // TODO
  listDeletionError: 'Erreur de suppression de la liste',
  listHighLow: 'Liste (haut-bas)',
  listImportedError:
    '% lignes contenaient des erreurs et n’ont pas pu être importées',
  listImported: 'Liste importée avec succès',
  listImportedSuccessfully: 'Votre liste a été importée avec succès (% lignes)',
  listLookup: 'Recherche dans la liste', // TODO
  listLowHigh: 'Liste (bas-haut)',
  listName: 'Nom de la liste',
  listNameAlreadyExists: 'Le nom de la liste existe déjà',
  listPrice: 'Prix de liste',
  listPriceBreakdown: 'Ventilation du prix de liste',
  lists: 'Listes',
  loadingXResults: '% résultats en cours de chargement', // TODO
  location: 'Emplacement',
  logOut: 'Se déconnecter',
  locationChangedTo: 'Emplacement changé à',
  lookupDate: 'Date de recherche',
  lookupItems: 'Articles de recherche',
  lookupSource: 'Source de recherche',
  lookupType: 'Type de recherche',
  lostSaleSuccess: 'Rapport de vente perdue envoyé',
  make: 'marque',
  makeThisMyDefaultState: 'Faire ceci l’état par défaut',
  manufacturer: 'Fabricant',
  manufacturers: 'Fabricants',
  manufacturerInfo: `Si vous connaissez le fabricant de la pièce que vous remplacez, sélectionnez-le ci-dessous Sinon, cliquez sur « Tout sélectionner »`, // TODO
  markAsFavorite: 'Marquer comme préféré',
  markedAsFavorite: 'Marqué comme préféré',
  mayNotFitYour: 'Peut ne pas convenir au véhicule sélectionné', // TODO
  mergeWithExistingCart: 'Combiner avec le chariot existant',
  message: 'Message',
  messageSent: 'Message envoyé !',
  messageSentSuccess:
    'Merci pour votre message ; on vous contactera selon la priorité.',
  method: 'Méthode', // TODO
  mfr: 'Fbr',
  mfrAZ: 'Fabricant (A-Z)', // TODO
  mfrZA: 'Fabricant (Z-A)', // TODO
  mileage: 'Kilométrage',
  minQty: 'Qté Min',
  minQuantity: 'Quantité minimale',
  miscellaneous: 'Divers',
  missingPartInbox: 'Boîte de réception des pièces manquantes',
  model: 'Modèle',
  more: 'plus',
  moreLocations: "Plus d'emplacements", // TODO - review
  moreOptions: 'Plus d’options',
  moreActions: 'Autres actions', // TODO
  move: 'Déplacer',
  moveGroup: 'Déplacer le groupe',
  moveItems: 'Déplacer des articles',
  moveList: 'Déplacer la liste',
  moveToAnotherList: 'Déplacer dans une autre liste',
  mustIncludeAPartToOrderThisCart:
    'doit inclure une pièce pour commander ce chariot',
  multiPartInquiry: 'requête en plusieurs parties',
  multiPartInquiryValidationError:
    'Code de ligne non valide, les caractères spéciaux ne sont pas autorisés/la longueur du code de ligne doit être de 2caractères minimum et de 3caractères maximum',
  myStore: 'Mon magasin',
  myPlaceForParts: 'MyPlace4Parts',
  multiSellerIntegrationNotResponding:
    'Multi-Seller integration is not responding for this seller. Please contact us for support',
  name: 'Nom',
  needHelpResettingYourPassword:
    'Vous avez besoin d’aide pour réinitialiser votre mot de passe ?',
  new: 'Nouveau',
  newCategory: 'Nouvelle catégorie',
  newGroup: 'Nouveau groupe',
  newList: 'Nouvelle liste',
  newLists: 'Nouvelles listes',
  newParts: 'Nouvelles pièces',
  newPassword: 'Nouveau mot de passe',
  newReturn: 'Nouveau retour',
  next: 'Suivant',
  nextChooseList: 'Suivant',
  nextSelectGroup: 'SUIVANT',
  nextSelectDescription: 'SUIVANT: sélectionner une description',
  nextSelectPartTypes: 'SUIVANT',
  noAdditionalDetails: 'Aucun détail supplémentaire',
  noData: 'Aucune donnée disponible',
  noDataForTheGivenPartDetails:
    'Aucune donnée disponible pour les détails de la pièce indiquée', // TODO
  noImage: 'Aucune image disponible',
  noMoreResults: 'Plus de résultats',
  noOrdersAvailable: 'Aucune ordres disponible',
  noInvoicesAvailable: 'Aucune ordres disponible', //TODO
  noPartsFoundForThisGroup: 'Aucune pièce trouvée dans ce groupe',
  noPartsFoundForThisList: 'Aucune pièce identifiée dans cette liste', // TODO
  noPartsFoundAddedToCart: `Aucune pièce n'a été ajoutée au panier`, // TODO
  noPartsCanBeAddedToCart: `Aucune pièce ne peut être ajoutée au panier car elles proviennent d’emplacements en lecture seule`,
  noQuotesAvailable: 'Aucun devis disponible',
  noResults: 'Aucun résultat', //To DO
  noResultsFound: 'Aucun résultat trouvé',
  noResultsFoundForHD: `AUCUN RÉSULTAT TROUVÉ POUR "%"`,
  noListResultsFound: 'Aucune liste identifiée', //TO DO
  noResultsFoundForThisVehicle: 'Aucun résultat trouvé pour ce véhicule',
  normal: 'Normal',
  note: 'Remarque',
  notes: 'Remarques',
  noteToStore: 'Remarque à stocker',
  notesToStore: 'Remarques à stocker',
  noVehicleHistoryAvailable: 'Aucun historique de véhicule disponible',
  oeCrossReference: 'OE Cross References', //TODO
  oePart: 'Pièce OE',
  oeParts: `Pièces d'origine`, //TODO
  oePartNumbersDisclaimer:
    'Les numéros de pièce OE pour référence uniquement. L’application devrait être vérifiée.',
  okIUnderstand: 'Bien, je comprends',
  onThisOrderFor: 'sur cette commande pour',
  onThisOrderForAnAutomaticEntry:
    'sur cette commande pour une entrée automatique.',
  onlineCatalog: 'Catalogue en ligne',

  onlyLaborResultsAreAddedToCart: `Seuls les résultats de main-d'œuvre sont ajoutés au panier`, //TODO
  onlyOutOfRequestedAreAvailable:
    'Disponibilité uniquement % sur % de la demande',
  'Only Priced': 'Seulement au Prix',
  onlySpecsAreAddedToCart: 'Seules les spécifications sont ajoutées au panier', //TODO

  onlySpecsLaborResultsAreAddedToCart:
    'Solo se añaden al carrito las especificaciones y los resultados de la mano de obra', //TODO
  'Only Stocked': 'Seulement en Stock',
  openGroups: 'Ouvrir groupes',

  or: 'OU',
  order: 'Commander',
  orderAllCarts: 'Commander tous les chariots',
  orderConfirmation: 'Confirmation de commande',
  orderConfirmationError: `Veuillez consulter le message d'erreur ci-dessus et renvoyer votre commande depuis la page Panier. Si le problème persiste, veuillez nous contacter`,
  orderAllCartsConfirmation:
    'Êtes-vous sûr(e) de vouloir commander tous les paniers ?', // TODO
  orderDate: 'Date de la commande', // TODO
  orderDetails: 'Détails de la commande',
  ordered: 'Commandé',
  orderedBy: 'Commandé par',
  orderedON: 'Commandé le',
  orderedFrom: 'Ordered From', // TODO
  orderedOn: 'Commandé le %',
  orderFailed: `Commande échouée`,
  orderForm: 'Formulaire de commande',
  orderFormIsIncomplete: 'Formulaire de commande incomplet.',
  orderHistory: 'Historique de commande',
  orderNotFound: 'Commande non trouvée',
  orderNumber: 'Numéro de commande',
  orders: 'Commandes',
  orderError: 'Error: Commande échouée. ',
  orderSummary: 'Sommaire de la commande',
  orderThisCart: 'COMMANDER CE CHARIOT',
  orderTotal: 'Total commande',
  orderFromPrimaryWarining:
    'Les commandes à cet endroit seront traitées par votre magasin local',
  OrdersWillBeProcessedByYourLocalStore:
    'Les commandes seront traitées par votre magasin local',
  orderType: 'Type de commande',
  orderConfirmationNumber: 'Confirmation de commande Id', //TODO
  other: 'Autre (veuillez spécifier)',
  others: 'Other',
  otherSellers: 'Other Sellers', // TODO
  outOf: 'rupture',
  outOfStock: 'Rupture de stock',
  outOfStockAtAllLocationsWillBeOrderedFromOtherStore:
    'Rupture de stock dans tous les emplacements, commander à partir du %',
  outOfStockAtUpdatedTo: 'rupture de stock au %, mise à jour le %',
  packed: 'Emballé',
  page: 'Page',
  part: 'Pièce',
  parts: 'Pièces',
  'Part#': 'Pièce #',
  partIsValidSubText: `Vous pouvez utiliser notre outil de référence croisée pour voir une liste complète de toutes les pièces d'origine et de rechange interchangeables avec % ou essayer une autre recherche`,
  partIsValidText: `% est un numéro de pièce valide, mais nous ne proposons pas cette pièce ni aucun produit interchangeable.`,
  partVehicleFitment: 'Pièce', //To DO
  partAvailableInAnotherGroup: 'Pièce disponible dans un autre groupe',
  partAvailableInCurrentScreen: 'Pièce disponible dans l’écran courant',
  partDescription: 'Description de la pièce',
  partDescriptionAZ: 'Description de la pièce (A-Z)',
  partDescriptionZA: 'Description de la pièce (Z-A)',
  partNum: 'No. de pièce',
  partNumber: "Numéro d'article",
  partNumberRequired: "Nº de pièce (Obligatoire)",
  partNumberRequiredShort: 'Nº de pièce',
  partNumberAZ: "Numéro d'article (A-Z)",
  partNumberZA: "Numéro d'article (Z-A)",
  partsCatalog: 'Catalogue de pièces',
  partSelected: 'Pièce sélectionnée',
  partType: 'Type de pièce',
  PartType: 'Type de pièce',
  partTypes: 'Types de pièces',
  partInquiry: 'Demande de pièces',
  partWasAddedToYourCart: '% ajouté au chariot',
  partWasRemovedFromYourCart: '% enlevé du chariot',
  partsHaveBeenAddedToYourCart: 'Les pièces ont été ajoutées à votre panier',
  password: 'Mot de passe',
  passwordReset: 'Réinitialiser le mot de passe',
  passwordsMustMatch: 'Les mots de passe doivent correspondre',
  pending: 'en attente',
  perCarQty: 'Qté par chariot',
  personalNote: 'Remarque personnelle',
  phoneNumber: 'Numéro de téléphone',
  phoneNumberRequired: 'Numéro de téléphone requis',
  pleaseContactForInformation: 'Veuillez contacter % pour plus d’informations',
  pleaseEnterTheCodeThatWasSentTo:
    'Veuillez entrer le code qui vous a été envoyé à %',
  pleaseEnterYourContactDetailsAndAnAdminWillBeInContactWithYou:
    'Veuillez entrer votre pseudonyme, adresse de courriel et numéro de téléphone ; un administrateur va vous contacter',
  pleaseEnterYourScreenNameToSendVerificationCode:
    'Veuillez entrer votre pseudonyme pour envoyer un code de vérification à votre adresse de courriel',
  pleaseReviewAndAcceptEulaAbove:
    'veuillez examiner et accepter eula au-dessus de', //TODO
  pleaseUploadValidCsvFile: 'veuillez télécharger un fichier CSV valide',
  pleaseUploadCsvFile: 'veuillez télécharger le fichier csv',
  pleaseReviewTheFollowingMessageBeforeConfirmingYourOrder:
    'Veuillez consulter le message suivant avant de confirmer votre commande. Vous pouvez poursuivre votre commande telle quelle, retourner à votre panier pour apporter des modifications, ou retirer des articles spécifiques ou un panier entier de votre commande. Les articles retirés resteront sur votre page de panier pour plus tard.',
  po: 'Bon de commande',
  poNumber: 'Numéro du bon de commande',
  poNumberIsTheSameForAllSellers:
    'Le numéro de commande est le même pour tous les vendeurs',
  previousSearches: 'Recherches précédentes',
  price: 'Prix',
  pricePerItem: 'Prix par article',
  primary: 'Primaire',
  print: 'Imprimer',
  printList: ' Imprimer liste',
  printCatalogDiagram: 'Imprimer le schéma du catalogue', //TODO
  priority: 'Priorité',
  ProcessedByLocalStore: 'Traité par le magasin local',
  productCantBeFulfilled:
    'Le produit ne peut pas être fourni de tous les emplacements',
  productCantBeFulfilledFromSelectedLocation:
    'Le produit ne peut pas être livré depuis l’emplacement sélectionné',
  productToThisOrderForAnAutomaticEntry:
    'product to this order for an automatic entry.', // TO DO
  products: 'Produits',
  productsWereAddedToTheCart: 'Les produits ont été ajoutés au chariot',
  promoPolicy:
    'pour les détails complets du tirage au sort. *Estimation. Entrées réelles MyPlace4Parts mises à jour dans les 24-48 heures',
  qty: 'Qté',
  qtyAZ: 'Quantité (petite - grande)', //TODO
  qtyZA: 'Quantité (grande - petite)', //TODO
  qtyPriceBreak: 'Prix proposé par qté',
  qtyToReturn: 'QTÉ À RETOURNER',
  quantity: 'Quantité',
  quantityPriceBreak: 'Prix proposé par quantité',
  quantityRequestedIsLessThanMinimum:
    'La quantité demandée est inférieure au minimum',
  quantityRequestedHasChanged: 'La quantité demandée a été modifiée.',
  quoteAmountText: `Le devis total représente le coût de tous les produits plus la main-d'œuvre.`,
  quoteDeletedSuccessfully: `% was successfully deleted`, // TODO
  quoteDetails: 'Détails du devis',
  quoteId: 'Identifiant du devis',
  quoteNotFound: 'Devis non trouvé',
  quoteNumber: 'Devis #%',
  quoteTotal: 'Total du devis',
  quoteUpdatedMsg: `La citation a été mise à jour avec succès`,
  quotes: 'Devis',
  quote: 'Citation',
  quotesOlderThan: 'devis plus anciens de',
  quoteSummary: 'Résumé du devis',
  quoteVehicleNotFound: 'Données du véhicule non trouvées sur le devis',
  rate: 'Taux',
  readLess: 'Lire moins',
  readMore: 'Lire plus',
  reason: 'Raison',
  reasonForReturn: 'RAISON DU RETOUR',
  recentOrders: 'Commandes récentes',
  recentSearches: 'Recherches récentes',
  recentVehicles: 'Véhicules récents',
  recommended: 'Recommandé',
  recommendedProductsFromYourSeller: 'Produits recommandés par votre vendeur', // TODO
  recommendedServices: 'Services recommandés',
  refreshPage: 'Refresh page', // TODO
  regular: 'Régulier',
  removeAll: 'Supprimer tout',
  removeAllCarts: 'Supprimer tous les chariots',
  removeCart: 'Supprimer le chariot',
  removeItem: `Retirer l'objet`,
  removeItemFromReturnRequest: `Supprimer l'article de la demande de retour`,
  removeYour: 'supprimer votre',
  removeCartFromOrder: 'Retirer le panier de la commande',
  removeItemFromOrder: "Retirer l'article de la commande",
  removeVehicleCart: 'Retirer le panier %',
  rename: 'Renommer',
  reName: 'Renommer',
  renameCategory: 'Renommer la catégorie',
  reNameGroup: 'Renommer le groupe',
  renameList: 'Renommer la liste',
  replacementFor: 'Remplacement pour',
  reportLostSale: 'Rapporter une vente perdue',
  requestDetails: 'Détails de la demande',
  requestAdditionalSellers: 'Request Additional Sellers', // TODO
  requestNewCode: 'Demander un nouveau code',
  requestPasswordReset: 'Demander de réinitialiser le mot de passe',
  resetYourPassword: 'Réinitialisez votre mot de passe',
  resortItems: 'Articles du complexe', // TODO
  results: 'Résultats',
  resultsFilter: 'Résultats Filtrer',
  resultsLoaded: 'Résultats chargés', // TODO
  returnAmountText:
    'Ce montant sera recrédité sur votre compte une fois la demande de retour traitée et autorisée.',
  returnRequest: 'Demande de Retour',
  returnRequestDetails: 'Détails de la demande de retour',
  requestReturn: 'Demander retour',
  requestReturnId: 'Demander un numéro de retour',
  resultsTableDensity: 'Densité du tableau des résultats',
  returnToThePartsCatalogToKeepShopping:
    'Revenir au catalogue de pièces pour continuer les achats.',
  returnToVehicleHistory: 'Return to vehicle history', // TODO
  returnToCart: 'Retourner au panier',
  reviewItemsaddedtocart: 'Analyser les articles ajoutés au chariot',
  reviewTheItemsYouWishToAddToList:
    'Vérifiez les articles que vous souhaitez ajouter à la liste',
  reviewTheItemsYouWishToAddToThisGroup:
    'Vérifiez les articles que vous souhaitez ajouter à ce groupe',
  rma: 'RMA',
  rmaRequest: 'Demande RMA',
  rmaConfirmation: 'Confirmation RMA',
  rollOverImageToMagnify: `Passer la souris sur l'image pour l’agrandir`,
  save: 'Sauvegarder',
  saveAll: 'Sauvegarder tout',
  saveAsQuote: 'Sauvegarder comme devis',
  saveChanges: 'Sauvegarder les changements',
  savePreferences: 'Sauvegarder les préférences',
  screenName: 'Pseudonyme',
  screenNameRequired: 'Pseudonyme requis',
  search: 'Rechercher',
  searchSettings: 'Paramètres de recherche',
  searchAllOrders:
    'Rechercher des commandes (par BC, numéro de pièce, véhicule)',
  searchAllInvoices:
    'Rechercher toutes les factures (par bon de commande, numéro de pièce, numéro de facture)', //TO DO
  searchAllQuotesBy:
    'Rechercher tous les devis (par bon de commande, numéro de pièce, notes, emplacement)',
  searchByLicensePlate: "Rechercher par plaque d'immatriculation",
  searchByVin: 'Rechercher par NIV',
  searchByYMME: 'Rechercher par année, marque, modèle',
  searchDate: 'Rechercher la date',
  searchForVehicles:
    "Recherche de véhicules (nom personnalisé, plaque d'immatriculation...)",
  searchManufacturers: 'Rechercher les fabricants',
  searchOnWeb: 'Rechercher sur le Web',
  searchPartBrandName:
    'Rechercher le numéro de pièce, la marque ou le nom de la pièce',
  searchParts: 'Rechercher des pièces',
  searchSalesPadUsersIndications:
    'Search Users(Account Name, Organization Name)', // TODO
  searchWithinResults: 'Rechercher dans les résultats',
  searchbyPartTypes: 'Recherche par types de pièces',
  secondary: 'Secondaire',
  seeLess: 'Voir moins',
  seeMore: 'Voir plus',
  select: 'Sélectionner',
  selectACart: 'Sélectionner un panier',
  selectAReason: 'Sélectionnez une raison',
  selectAConditionToChangeGraphic:
    'Sélectionner une condition pour changer le graphique affiché',
  selectAll: 'Tout sélectionner',
  selectAllItemsInThisList: 'Sélectionnez tous les éléments de cette liste',
  selectAVehicle: 'Sélectionner un véhicule',
  selectAnotherLocation: 'Sélectionner un autre emplacement', //TO DO
  selectCartToAddItem: 'Sélectionner le chariot pour ajouter l’article',
  selectCategory: 'Sélectionner la catégorie',
  selected: 'sélectionné',
  selectedAcross: 'sélectionné à travers',
  selectFromManufacturer: `Sélectionnez "Du" fabricant`,
  selectFromManufacturerDescription: `Optimiser ma recherche d'échange en affichant d'abord tous les fabricants "de" qui correspondent au numéro de pièce spécifié avant d'afficher mes résultats`,
  selectedLines: 'Ligne sélectionnées',
  sellerOrder: '% Order', // TODO
  selectGfxAndFitmentConditions: 'Sélectionner GFX et conditions de montage',
  selectGroup: 'Sélectionner groupe',
  selectManufactureLines:
    'Sélectionner les lignes de fabricant pour lesquelles vous aimeriez voir les résultats.',
  selectManufacturersUpto: 'Vous pouvez sélectionner jusqu’à 10 fabricants.',
  selectOneOrMoreCategoriesToDisplayCorrespondingGroups:
    'Sélectionnez une ou plusieurs catégories pour afficher les groupes correspondants', // TODO
  selectOneOrMoreCategoriesToDisplayCorrespondingJobs:
    'Sélectionner une ou plusieurs catégories pour afficher les emplois correspondants', // TODO
  selectOneOrMoreGroupsToDisplayCorrespondingPartTypes:
    'Sélectionner un ou plusieurs emplois pour afficher les types de pièces correspondants', // TODO
  selectOneOrMoreJobsToDisplayCorrespondingPartTypes:
    'Sélectionner un ou plusieurs emplois pour afficher les types de pièces correspondants', // TODO
  selectMethod: 'Sélectionner la méthode', // TODO
  selectPartType: 'Sélectionner le type de pièce',
  selectPartTypes: 'seleccionar tipos de pieza', // TODO
  selectThenBy: `Sélectionner 'Puis par'`,
  selectVehicle: 'Sélectionner véhicule',
  selectVehicleEngine: 'Sélectionner le moteur du véhicule',
  selectYourPreferredDefaultVehicleTypeWhenDoingAYMMESearch:
    'Select your preferred default vehicle type when doing a YMME search',
  sendAMessageTo: 'Envoyer un message à',
  sendAnother: 'Envoyer un autre',
  sendCode: 'Envoyer un code',
  sendMessage: 'Envoyer le message',
  sendUsaMessage: 'Envoyez-nous un message',
  separateMultiplePartNumbers:
    'Séparer plusieurs no. de pièce avec des espaces',
  separateMultiplePartNumbersWithSpaces:
    'séparer plusieurs numéros de pièce avec des espaces',
  serviceIntervals: 'Intervalles de service',
  servicesIntervalType: 'Type des intervalles de service',
  setLaborRate: 'Établir le tarif de main d’œuvre',
  severe: 'Grave',

  shipByCourier: 'Expédier par courrier',
  shipTo: 'Livrer à',
  shipment: 'Livraison',
  shipmentCost: "Coût d'expédition",
  shipped: 'Livré',
  shippedFrom: 'Livré de',
  shipping: 'Expédition',
  shippingCostIsUpdated:
    "Vos frais d'expédition ont changé en fonction de la quantité mise à jour",
  shippingId: 'Identifiant de livraison',
  // i.e: "Commandes 1-10 sur 391 affichées",
  'Show All': 'Afficher Tout',
  showGraphic: 'Afficher le graphique',
  showingResultsFor: 'Afficher les résultats pour',
  showing: 'montrant',
  showResults: 'Afficher les résultats',
  showLess: 'Afficher moins', // TODO
  showMore: 'Afficher plus', // TODO
  skillLevel: 'Niveau de compétences',
  skipAndSeeAllResults: 'Passer et voir tous les résultats',
  sort: 'Trier',
  sortBy: 'Trier par',
  sortGroup: 'Trier le groupe', // TODO
  sortHasNotYetBeenApplied: `Le tri n'a pas encore été appliqué`, // TODO
  sortMultiSellerTabs: 'Sort Multi-Seller Tabs', // TODO
  sortResult: 'Trier les résultats', //TODO
  sortSellers: 'Trier les Vendeurs',
  sortSellerDrawerInstructions:
    'Drag and drop the available sellers to arrange them in your preferred display order.', // TODO
  spanish: 'Espagnol',
  source: 'Source', // TODO
  soldBy: 'Sold by %', // TODO
  specifications: 'Spécifications',
  specificationSearch: 'Spécifications de recherche',
  specificationUpdate: 'Spécifications mises à jour',
  specify: 'Si autre, veuillez spécifier',
  startNewCart: 'Commencer nouveau chariot',
  state: 'État',
  status: 'État',
  statusUnavailable: 'Statut indisponible', // TODO
  stock: 'Action',
  stockOptionAll: 'Tous',
  stockOptionInStock: 'En stock',
  subject: 'Sujet',
  submit: 'soumettre',
  subOperation: 'Sous-opération',
  subModelOptional: 'Sous-modèle (Facultatif)',
  successfullyCreatedCategory: 'Catégorie créée avec succès',
  successfullyCreatedGroup: 'Groupe créé avec succès',
  successfullyCreatedList: 'Liste créée avec succès',
  successfullyDeletedCategory: 'Catégorie supprimée avec succès',
  successfullyDeletedGroup: 'Groupe supprimé avec succès',
  successfullyDeletedList: 'Liste supprimée avec succès',
  successfullyListMoved: 'Liste déplacée avec succès',
  successfullyUpdatedCategory: 'Catégorie mise à jour avec succès',
  successfullyUpdatedGroup: 'Groupe mis à jour avec succès',
  successfullyUpdatedList: 'Liste mise à jour avec succès',
  summary: 'Sommaire',
  switchOrg: `Changer d'organisation`, //TODO
  theFollowingItemsWereLoaded:
    'Les éléments suivants ont été chargés après un tri personnalisé. Pour appliquer votre tri aux éléments ci-dessous, cliquez sur « Trier les éléments ».', // TODO
  theMinimumOrderQuantityIs: 'La quantité minimum de commande est %.',
  thenBy: 'Puis par',
  thePartWasAddedToYourCart: 'La pièce a été ajoutée au chariot',
  fewOfThePartsWereNotAddedToCart:
    'Algunas de las piezas no se agregaron al carrito', //TODO
  NoPartWasNotAddedToTheCart: `Aucune pièce n'a été ajoutée à votre panier`, //TODO
  theQuantityRequestedIsNotAvailable:
    "La quantité demandée n'est pas disponible",
  theseItemsWereUnavailableFromOurDatabase:
    'Ces articles n’étaient pas disponibles dans notre base de données',
  thesePartsMayNotFitYour:
    'Ces pièces peuvent ne pas être compatibles avec votre',
  theseTicketsWillNotBeSentOnTheTicketToTheWarehouse:
    'Ces champs ne seront pas envoyés sur la note au dépôt.',
  theServerDidNotRespondOnTimePleaseTryAgainInAFewMoments: `Le serveur n'a pas répondu à temps. Veuillez réessayer dans quelques instants.`, // TODO
  thisCannotBeUndone: 'Cette action ne peut pas être annulée.',
  thisGroupIsEmpty: 'CE GROUPE EST VIDE',
  thisIncludesTheFollowingCarts: 'Cela comprend les chariots ci-dessous',
  thisItemWasUnavailableFromOurDatabase:
    'Cet article n’était pas disponible dans notre base de données',
  thisOrderHasQualifiedFor: 'Cette commande s’est qualifiée pour',
  thisOrderWasPlacedThroughAnotherSellerAndTrackingIsUnavailable:
    'This order was placed through another seller and tracking is unavailable.', // TODO
  thisQuoteCantBeFulfilled: 'Ce devis ne peut pas être honoré',
  thisVinIsInvalidTryAgain:
    'Ce NIV est invalide. Veuillez vérifier le NIV et réessayer.',
  invalidQuery:
    'Requête non valide, le terme recherché doit avoir au moins 3 caractères', //TODO
  thisWeek: 'Cette semaine',
  thisWillRemoveAllItemsFromTheCartAndCannotBeUndone:
    'Cette action va enlever tous les articles du chariot, sans pouvoir être annulée.',

  today: 'Aujourd’hui',
  to: 'à',
  toEnsureWeCanFindTheBestMatchPleaseEnterVehicleInformation:
    'Pour nous assurer que nous pouvons trouver la meilleure correspondance, veuillez saisir les informations sur le véhicule',
  tomorrow: 'Demain',
  total: 'Total',
  totalApplications: 'total Applications',
  toHideAnItemClickTheEyeIcon: 'To hide an item, click the eye icon', // TODO
  totalCost: 'Total coût',
  totalHours: 'Total heures',
  totalList: 'Total liste',
  totalQty: 'Total QTÉ',
  trackingHistory: 'Historique de suivi',
  trackingInformationIsNotYetAvailable:
    'Les informations de suivi ne sont pas encore disponibles pour cet envoi, veuillez revenir plus tard', //TODO
  trackingShipment: 'Suivi d’expédition',
  transfer: 'Transfert',
  transport: 'Transport',
  tryAdjustingYourFilters: 'Essayer de régler les filtres',
  tryAdjustingYourSearchOrLookupPartsInOurDatabase:
    'Essayer de régler la recherche ou rechercher des pièces dans notre base de données',
  tryAgain: 'Essayer à nouveau',
  tryANewSearchOrEditYourFitmentConditions:
    'Essayer une nouvelle recherche ou modifier les conditions de montage',
  tryANewSearchOrUseThePartsCatalog:
    'Essayer une nouvelle recherche ou utiliser le catalogue de pièces',
  trySelectingDifferentGroups:
    'Essayer de sélectionner des groupes différents ou de rechercher un autre véhicule',
  tryUsingADifferentKeywordCheckingForTyposOrAdjustingYourFilters:
    'Try using a different keyword, checking for typos, or adjusting your filters', // TODO
  type: 'Taper',
  typeANameForThisVehicle: 'Taper un nom pour ce véhicule',
  unableToFetchManufacturer: 'Unable to fetch manufacturer',
  unableToFetchPartTypes: 'Unable to fetch part types',
  unableToPlaceOrder: 'Impossible de passer la commande',
  unableToPlaceOrderError: `Impossible de passer la commande: Demande de pièce/Erreur de commande`,
  unableToPlaceOrderPleaseContactTheAdministrator:
    'Impossible de passer la commande. Veuillez contacter l’administrateur.',
  unavailableGroupGraphic: 'Graphique de groupe indisponible',
  unavailablePartTypes: 'Types de pièces indisponibles',
  unavailableProductDetails: 'Détails du produit indisponibles',
  unableToConnect: 'Unable to connect',
  unableToFetchSellers: 'Impossible de récupérer les vendeurs',
  underWarranty: 'Sous garantie',
  unDone: 'Cette action ne peut pas être annulée.',
  unknownAftermarketAvailability:
    'Disponibilité inconnue sur le marché secondaire',
  unknownError: "Une erreur inconnue s'est produite",
  unSelectAll: `désélectionner Tout`,
  update: 'Mise à jour',
  updateCart: 'Mise à jour du chariot',
  updateList: 'Mise à jour de la liste',
  updateQuote: 'Mise à jour du devis',
  updateVehicle: 'Mise à jour du véhicule',
  updatingYourVehicleWillChangeSearch:
    'La mise à jour du véhicule va changer les résultats actuels de recherche. Voulez-vous continuer la mise à jour ?',
  urgent: 'Urgent',
  user: 'Utilisateur',
  usedPartInbox: `Boîte de réception des pièces d'occasion`,
  useTemplateCsv: 'Utilisez notre liste de modèles (CSV)',
  vehicle: 'Véhicule',
  vehicleClear: 'claire',
  vehicleDeleted: 'Véhicule supprimé',
  vehicleDeletedSuccessfully: 'Véhicule supprimé avec succès',
  vehicleFitment: 'Adaptation au véhicule',
  vehicleFitmentUnavailable:
    'L’adaptation au véhicule est indisponible pour ce produit.',
  vehicleHistory: 'Historique du véhicule',
  vehicleIncomplete: 'Véhicule incomplet',
  vehicleInformationWasIncomplete:
    'Données du véhicules incomplètes. Veuillez ajouter les autres données du véhicule',
  vehicleInfoRetrievalError:
    'Une erreur a eu lieu lors de la récupération des informations sur le véhicule', // TODO
  vehicleLicensePlate: "Plaque d'immatriculation",
  vehicleNotFound: 'Véhicule non trouvé',
  vehicleQuickFind: 'Recherche rapide de véhicule', // TODO
  vehicleRequired: 'Véhicule requis',
  vehicleRequiredForSearch: 'Veuillez sélectionner un véhicule manuellement.',
  vehicles: 'Véhicules',
  vehicleSearch: 'Rechercher véhicules',
  vehicleSpecification: 'Spécification',
  vehicleSuccessfullyDeleted: 'Véhicule supprimé avec succès',
  vehicleTotal: 'Véhicule Total',
  vehicleType: 'Type de véhicule',
  vehicleTypeDropdown: 'Vehicle type dropdown', // TODO
  vehicleVIN: 'NIV',
  vehicleYMME: 'Année / Marque / Modèle / Moteur',
  verifyingQuantityAvailable: 'Vérification de la quantité disponible...',
  verifyingTheItemsInOurDatabase:
    'Vérification des articles dans notre base de données...',
  verifyingTheLocationForItems: 'Vérification de l’emplacement des articles...',
  viewCart: 'Visualiser le chariot',
  viewDetails: 'Visualiser les détails',
  viewIn360: 'View in 360°', // TODO
  viewLists: 'Visualiser les listes',
  viewMore: 'Visualiser plus',
  viewOnly: 'Visualiser uniquement',
  viewOnlyLocationMessage: `Afficher l'emplacement uniquement. Veuillez sélectionner votre entrepôt ou magasin local pour passer commande`, // TODO
  viewOrderDetails: 'Visualiser les détails de la commande',
  viewOrPrint: 'Visualiser ou imprimer le reçu',
  viewOrPrintQuote: 'Visualiser ou imprimer le devis',
  viewPartAvailabilityInListBelow:
    'Visualiser la disponibilité de la pièce dans la liste ci-dessous',
  viewPreviousSearches: 'Visualiser les recherches précédentes',
  viewQuoteDetails: 'Visualiser les détails du devis',
  viewVinDetails: 'Visualiser les détails du NIV',
  vin: 'VIN',
  vinAutoCorrected: 'Numéro NIV corrigé automatiquement à %',
  vinScan: 'VIN analyse',
  vinCode: 'Code NIV',
  vinDetails: 'Détails du NIV',
  viewQuotes: 'Voir les devis',
  vinMustContain17Characters: 'Le NIV doit avoir 17 caractères',
  vinPattern: 'Modèle NIV',
  visitTheWebsiteForOrderDetails:
    'Visiter le site Web pour les détails de la commande',
  warranty: 'Garantie',
  warrantyHours: 'Heures de garantie',
  warrantyInfo: 'Informations de garantie',
  wasAddedToList: 'a été ajouté à la liste',
  wasSavedAsQuote: '% a été enregistré comme devis',
  weAreUnableToRequestReturnsFromThisSellerDisclaimer:
    'We are unable to request returns for this seller. Contact seller directly to return items from this order.', // TODO
  weAreValidatingAvailability:
    'Nous sommes en train de vérifier la disponibilité.',
  weWereUnableToProcessYourRequest: `Nous n'avons pas pu traiter votre demande. Veuillez réessayer et contacter votre fournisseur de pièces si le problème persiste.`,
  weight: 'Lester',
  wereSorryAGraphicFor: 'Désolé, un graphique pour',
  wereSorryTheProductDetailsFor:
    '% articles dans votre chariot ne peut pas être fourni',
  whyAreYouReturningThisPart: 'Pourquoi retournez-vous cette pièce?',
  wrongPartFromCatalog: 'Mauvaise pièce du catalogue',
  wildCardSearchNotAllowedText: `La recherche par caractères génériques n'est pas autorisée`,
  wtyHours: 'Heures de GARANTIE',
  year: 'Année',
  years: 'Années',
  yesEmpty: 'Oui, vider',
  yesIUnderstand: 'Oui, je comprends',
  yesterday: 'Hier',
  youHaveMultipleOpenCartsInYourShoppingCart:
    'Vous avez plusieurs paniers ouverts dans votre panier',
  youHaveReachedTheMaximumNumberOfEntries:
    'Vous avez atteint le nombre maximum d’entrées.',
  youHaveEntryToDate: 'Vous avez % entrée(s) jusqu’à présent', // TODO
  yourCartIsEmpty: 'Votre chariot est vide',
  yourCartWasSuccessfullyEmptied: 'Votre chariot a été vidé avec succès',
  yourCost: 'Votre coût',
  yourFiltersReturnedNoResults: 'Vos filtres n’ont généré aucun résultat',
  yourFirstItemWillBeYourDefault:
    'Votre premier article sera l’article par défaut',
  yourSearchReturnedNoResults: 'Votre recherche n’a généré aucun résultat',
  zeroAvailableAtLocation: '0 disponible à %',
  'Not Available': 'Pas disponible',
  'Price Too High': 'prix trop élevé',
  'Prefer Different Brand': 'préfère une autre marque',
  oopsSomethingWentWrong: 'Oups ! Un problème est survenu',
  Other: 'autre',
  otherInfo: 'Autre',
  CAR: 'VOITURE', //TO DO
  TRUCK: 'CAMION', //TO DO
  'MEDIUM DUTY': 'SERVICE MOYEN', //TO DO
  '# Parts': '# Pièces',
  addPartsToGroup: `Ajouter pièces au groupe`,
  addPrompt: 'Ajouter message',
  addTheItemsYouWishToIncludeInThisGroup:
    'Ajouter les articles que vous aimeriez inclure dans ce groupe',
  additionalResources: 'Ressources supplémentaires',
  aftermarketAutoPartsAlliance: '',
  and: 'Et',
  arrivingOn: 'Arrivée le',
  ast: 'AST',
  associatedOrganizations: 'Associated Organizations', // TODO
  backToHome: `Retour à l’accueil`,
  basicDetails: 'Détails de base',
  bundled: `Regroupé`,
  bundleEligible: 'Offre groupée éligible',
  bundleSavings: 'Économies groupées :',
  bundleSavingsWithOutColon: 'Économies groupées',
  buyer: 'Acheteur',
  cancelRequest: 'Annuler demande',
  chooseFile: 'Choisir fichier',
  chooseMethod: 'Choisir méthode',
  comment: 'Commentaire',
  confirmationNumber: 'Numéro de confirmation',
  contactUsFormErrorMessage:
    'Une erreur a eu lieu. Veuillez réessayer plus tard',
  continue: 'Continuer',
  controlID: 'Identifiant de contrôle',
  deliveryTime: 'Durée de livraison',
  deselectAll: 'Déselectionner tout',
  directOrder: 'Commande directe',
  discardAndStartNew: 'Annuler et recommencer',
  discardAndStartNewCartMessage:
    'Vous avez des articles dans votre panier pour le véhicule actuel. Souhaitez-vous supprimer ces articles et commencer une nouvelle commande ?',
  discardChanges: 'Supprimer les modifications',
  documentID: 'Identifiant de document',
  dragAndRearrangeTheItemsInThisList:
    'Faire glisser et réorganiser les articles dans cette liste',
  duplicateFound: 'Articles en double identifiés',
  duplicateItemsFoundWithMatchingPartNumbers:
    'Articles en double identifiés avec des numéros de pièce correspondants',
  dragAndDropItHere: 'ou glisser et déposer ici',
  enterItems: 'Saisir les articles',
  errorInReloadingVehicleFitments:
    'Erreur lors du rechargement des équipements du véhicule',
  errorUpdatingLaborRate: `Erreur lors de la mise à jour du taux de main-d'œuvre`,
  estimatedReturn: 'Retour estimé',
  goToASTCatalog: 'Aller au catalogue AST (Accessoires, fournitures et outils)',
  goToHome: `Aller à la page d'accueil`,
  goToProductPage: 'Aller à la page du produit',
  hasNMatches: 'a % correspondances',
  hold: 'Attendre',
  importMultipleItemsFromCSVFile: `Importer plusieurs articles à partir d'un fichier CSV`,
  itemsWereNotAddedToYourCart: `% des articles n'ont pas été ajoutés à votre panier`,
  itemFromYourCartIsUnavailable: `1 article de votre panier n'est pas disponible`,
  itemsFromYourCartAreUnavailable:
    '% des articles de votre panier ne sont pas disponibles',
  itemSuccessfullyDeleted: 'Article supprimé avec succès',
  itemSuccessfullyUpdated: 'Article mis à jour avec succès',
  interchangeSearch: `Recherche d'échange`,
  invalidCredentials: 'Données non valides',
  invalidPart: 'Pièce non valide',
  invoice: 'Facture',
  invoiceDate: 'Date de la facture',
  itemNotFoundInOurDatabase:
    'article non identifié dans notre base de données.',
  oneItemNotFoundInOurDatabase:
    '1 article non identifié dans notre base de données.',
  itemFoundWithDuplicatePartNumbersFromDifferentManufacturers:
    'article identifié avec un numéro de pièce en double provenant de différents fabricants.',
  oneItemFoundWithDuplicatePartNumbersFromDifferentManufacturers:
    '1 article identifié avec un numéro de pièce en double provenant de différents fabricants.',
  itemInYourCartWillBeOrderedFromNonPrimaryLocation: `1 article de votre panier sera commandé à partir d'un emplacement secondaire.`,
  itemsAddedToGroupMsg: `% d'articles ajoutés dans % de groupes.`,
  itemsNotFoundInOurDatabase:
    '% d’articles non identifiés dans notre base de données.',
  itemsFoundWithDuplicatePartNumbersFromDifferentManufacturers:
    '% d’articles identifiés avec des numéros de pièce en double provenant de différents fabricants.',
  itemsInYourCartWillBeOrderedFromNonPrimaryLocation: `% d'articles de votre panier seront commandés à partir d'un emplacement secondaire.`,
  laborRateUpdatedSuccessfully: 'Taux de main d’œuvre mis à jour avec succès',
  tackNo: 'No. de suivi',
  tapAndRollOverImageToMagnify: `Appuyer et faire glisser sur l'image pour l'agrandir.`,
  TotalCostInHours: 'Coût total en heures',
  totalCount: 'Compte total',
  listImportTimeOutMsg: `Le serveur n'a pas répondu à temps. Veuillez réessayer dans quelques instants.`,
  locationType: 'Type de l’emplacement',
  locationSecNo: 'No. sec. de l’emplacement',
  manufacturerDetails: 'Détails du fabricant',
  mfrValidationMessage:
    'Le code de ligne ne doit pas comporter moins de % ni plus de % caractères.',
  moreDetails: 'Plus de détails',
  moreThanOneItemWasFoundWithMatchingPartNumbersFromDifferentManufacturers:
    'Plusieurs articles ont été identifiés avec des numéros de pièce correspondants provenant de différents fabricants.',
  noServiceInterval: 'Intervalle de service indisponible',
  notAddedDueToInsufficientQuantity: `Non ajouté en raison d'une quantité insuffisante.`,
  notPrimaryLocation: 'Emplacement non primaire.',
  openImageInNewTab: `Ouvrir l'image dans un nouvel onglet.`,
  orderSequence: 'Hiérarchie des ordres',
  organizationSelection: 'Organization Selection', // TODO
  orgID: `Identifiant de l'organisation`,
  origin: 'Origine',
  partIsAlreadyInCartFor: 'La pièce est déjà dans le panier pour',
  partIsNotVaildText: `Nous n'avons pas identifié de numéro de pièce valide correspondant à %`,
  partIsNotVaildSubText: `Veuillez vérifier l'exactitude du numéro de pièce ou effectuer une autre recherche`,
  partNumberIsEmpty: 'Le numéro de pièce est vide',
  plateNumber: 'Numéro de plaque',
  pleaseAddAVehicleToEnsureFitment:
    'Veuillez ajouter un véhicule pour garantir la correspondance',
  pleaseCheckYourFileToEnsureItMeetsTheRequirementsListedAbove: `Veuillez vérifier votre fichier afin de vous assurer qu'il répond aux exigences énumérées ci-dessus.`,
  pleaseSelectTheItemsYouWishToInclude:
    'Veuillez sélectionner les articles que vous souhaitez inclure.',
  poID: '',
  goToProductPageToSelectAnotherLocation:
    'aller à la page du produit pour sélectionner un autre emplacement.',
  purchaseOrderNumber: 'Numéro de bon de commande',
  requestSummary: 'Résumé de la demande',
  required: 'Requis',
  returnSummary: 'Résumé du retour',
  released: 'Publié le ',
  releasedBy: 'Publié par',
  recommendedServicesBody: `Sélectionner un type d'intervalle d'entretien et un kilométrage pour voir les services recommandés.`,
  renameGroup: 'Renommer le groupe',
  review: 'Réviser',
  reviewItem: `Réviser l'article`,
  reviewItems: 'Réviser les articles',
  rollOverImageToZoom: `Passer la souris sur l'image pour l’agrandir`,
  searchByTabOrder: 'Ordre d’onglets « Rechercher par »',
  searchTermShouldBeMinimum2Characters:
    'Le terme recherché doit comporter au moins 2 caractères.',
  searchTermShouldBeMinimum3Characters:
    'Le terme recherché doit comporter au moins 3 caractères.',
  selectAllXItemsInGroup: 'Sélectionner tous les articles % dans le groupe.',
  selectAllParts: 'Sélectionner toutes les pièces.',
  selectDescription: 'Sélectionner la description',
  selectPartsToReturn: 'Sélectionner les pièces à retourner',
  selectXItemsOnPage: 'Sélectionner % articles sur la page',
  selectYourItems: 'Sélectionner vos articles',
  seller: 'Vendeur',
  sellFromID: 'Identifiant du vendeur',
  sellFromName: 'Nom du vendeur',
  sellToID: `Identifiant de l'acheteur`,
  sellToName: `Nom de l'acheteur`,
  shipFromAddress: `Adresse de l'expéditeur`,
  shipFromID: `Identifiant de l'expéditeur`,
  shipFromName: `Nom de l'expéditeur`,
  shipInstructions: `Instructions d'expédition`,
  shipToAddress: `Adresse d'expédition`,
  shipToName: `Nom de l'acheteur`,
  startNewOrder: 'Commencer une nouvelle commande ?',
  stockQty: 'Quantité en stock',
  temporarilyUnavailable: 'Temporairement indisponible',
  theFileShouldIncludeColumnsWithHeadingsForGroupMFRPartNumberStockingQtyandComments:
    'Le fichier doit inclure des colonnes intitulées « Groupe », « MFR (Fabricant) », « No. de pièce », « Quantité en stock » et « Commentaires ».',
  thePageYourRequestedCouldNotBeFound:
    'La page que vous avez demandée est introuvable.',
  editThisItemToAddItToYourCart: `Modifier cet article pour l'ajouter au panier.`,
  theQuoteWasSavedSuccessfully: 'Le devis a été sauvegardé avec succès.',
  theSelectedPartsWillAppearHear:
    'Les pièces sélectionnées seront affichées ici.',
  thisItemWasNotFoundInOurDatabase:
    'L’article n’a pas été identifié dans notre base de données.',
  thisMayTakeAMoment: 'Cela peut durer un certain temps.',
  totalCore: 'Total base',
  totalLabor: 'Total main d’œuvre',
  totals: 'Totaux',
  totalTransport: 'Total transport',
  tracking: 'Suivi',
  transID: 'Identifiant trans',
  uid: 'UID (Identifiant unique)',
  unavailableAt: 'Indisponible chez %',
  unknown: 'inconnu',
  unknownItem: 'article inconnu',
  uploadFailed: 'Téléchargement échoué',
  useOurTemplateListFile: 'Utilisez notre fichier modèle',
  userDetails: `Détails de l'utilisateur`,
  userID: 'Identifiant de l’utilisateur',
  validate: 'Valider',
  validateItems: 'Valider les articles',
  validatingItems: 'Validation des articles en cours',
  vehicleName: 'Nom du véhicule',
  verifiedPart: 'Pièce vérifiée',
  warning: 'Avertissement',
  wasSuccessfullyUpdate: 'a été mis(e) à jour avec succès',
  weWereUnableToFindThisItemInOurDatabase: `Nous n'avons pas identifié cet article dans notre base de données`,
  willBeOrderFromANonPrimaryLocation:
    'sera commandé auprès de %, un emplacement secondaire',
  itemAddedFromMultipleLocationsTooltipDisclaimer:
    'Item added from multiple locations. Select More Locations to update quantity.', // TODO
  'Auto/Light-Medium Truck': 'Auto/Light-Medium Truck',
  'Medium-Heavy Duty Truck': 'Medium-Heavy Duty Truck',
  Motorcycle: 'Motorcycle',
  'ATV/UTV': 'ATV/UTV',
  Scooter: 'Scooter',
  Snowmobile: 'Snowmobile',
  Watercraft: 'Watercraft',
  Primary: 'Primaire',
  Secondary: 'Secondaire',
  'All Lines': 'Toutes les Lignes',
  optional: 'Optional',
  undo: 'Undo',
  finish: 'Finish',
  yes: 'Oui',
  no: 'Non',
  selectACategory: 'Sélectionnez une Catégorie',
  selectAList: 'Sélectionnez une Liste',
  selectAGroup: 'Sélectionnez un Groupe',
  successfullyPartsHaveBeenMoved: 'Successfully parts have been moved',
  successfullyDeletedPart: 'Successfully deleted part',
  selectMileage: 'Select Mileage',
  noOptions: 'No options',
  selectPlaceholder: 'Select...',
  miscellaneousText: 'MISCELLANEOUS',
  itemAddedToListMessage: '% was added to list: %',
  itemAddedToList: '% was added to list',
  itsTakingLongerThanUsualToPerformYourInquiry:
    'Votre demande prend plus de temps que prévu. Veuillez patienter...',
  yourOrderIsBeingProcessedLeavingMayResultInDuplicateOrders:
    'Votre commande est en cours de traitement. Si vous partez maintenant, cela peut entraîner des commandes en double.',
  itsTakingLongerThanUsualToProcessYourOrder: `Le traitement de votre commande prend plus de temps que d'habitude.`,
  pleaseTryAgainAndContactYourPartsSupplier:
    'Veuillez réessayer et contacter votre fournisseur de pièces si le problème persiste.',
  youCanAlsoCloseThisAndReturnLater:
    'Vous pouvez également fermer cette page et revenir plus tard ; votre panier sera toujours là.',
  expand: 'Développer',
  searchByManufacturerPartNumber: 'Rechercher par fabricant, numéro de pièce',
  selectOrderType: 'Sélectionner le type de commande',
  selectTransportType: 'Sélectionner le type de transport',
  showNewerYears: 'Afficher les années plus récentes',
  showEarlierYears: 'Afficher les années antérieures',
  appliedFilters: 'Filtres appliqués',
  resultsViewSettings: `Paramètres d'affichage des résultats`,
  moreResultActions: `Plus d'actions sur les résultats`,
  filterAndSortResults: 'Filtrer et trier les résultats',
  areYouSureYouWantToProceed: 'Voulez-vous vraiment continuer ?',
  applyResultFilter: 'Appliquer le filtre de résultats',
  imageLoadError: `Un problème est survenu lors du chargement de votre image`,
  companyLogo: 'Logo MyPlace4Parts',
  crossReferenceIcon: 'Icône de référence croisée',
  shippedStatus: 'Expédié',
  deliveredStatus: 'Livré',
  orderedWithCount: 'Commandé (%)',
  packedWithCount: 'Emballé (%)',
  shippedWithCount: 'Expédié (%)',
  deliveredWithCount: 'Livré (%)',
  itemUnit: 'article',
  itemsUnit: 'articles',
  driver: 'Chauffeur',
  switchLookup: 'Changer la recherche',
  remove: 'Supprimer',
  proceedWithOrder: 'Procéder à la commande',
  orderExceptionsMessage: 'Exceptions de commande',
  orderExceptionsSubMessage:
    'Un ou plusieurs articles nécessitent votre attention, veuillez vérifier avant de passer votre commande.',
  displayExclTax: 'Hors Taxes',
}
